import React from 'react';
import KaAlert from '../Common/KaAlert';
import { FormCheckbox } from '../Common/FormCheckbox';
import SpinnerButton from '../Common/SpinnerButton';
import { useSelectedBusiness } from '../UserAccess/useSelectedBusiness';
import KaModal from '../Common/KaModal';
import useUserRequest, { UserRequestSpec } from '../Common/useUserRequest';
import { HttpMethod } from '../Common/useFetch';
import useDisplayMessage from '../Common/useDisplayMessage';
import { BusinessUserDto, UserRoleDto } from '../Requests/useGetUsers';
import { Path, useForm } from 'react-hook-form';
import { RowFormSelectSearch } from '../Common/Forms/SelectSearch';
import { toRoleSelectOptions } from './userRoles';

interface IProps {
  businessUser: BusinessUserDto;
  roles: UserRoleDto[];
  visible: boolean;
  onHide: () => void;
  onSuccess: () => void;
}

interface EditUserDto {
  userRoleId: string;
  errorRecipient: boolean;
}

const putSpec = (businessId: string, userId: string): UserRequestSpec => ({
  path: `/api/businesses/${businessId}/users/${userId}`,
  method: HttpMethod.PUT,
});

export const EditUser = (props: IProps) => {
  const business = useSelectedBusiness();
  const displayMessage = useDisplayMessage();
  const requestSpec = putSpec(business.id, props.businessUser.id);

  const { register, handleSubmit, setValue, formState: { errors } } = useForm<EditUserDto>({
    defaultValues: { userRoleId: props.businessUser.userRoleId, errorRecipient: props.businessUser.isErrorRecipient }
  });

  const editUser = useUserRequest<EditUserDto>(requestSpec, {
    onSuccess: () => props.onSuccess(),
    onError: (e) => displayMessage.fail(e.message),
  });

  const hookProps = (name: Path<EditUserDto>) => ({
    labelSpace: 3,
    inputSpace: 8,
    name: name,
    setValue,
    register,
    errors,
  })

  const onClose = () => {
    props.onHide();
    displayMessage.clear();
  };

  return (
    <KaModal
      onHide={onClose}
      show={props.visible}
      title={`Edit ${props.businessUser.emailAddress}`}
      body={(<>
        <KaAlert displayMessage={displayMessage.message} onClose={displayMessage.clear} />
        <RowFormSelectSearch displayName="Role"
          id="userRoleId"
          {...hookProps("userRoleId")}
          selectedValue={props.businessUser.userRoleId}
          hideSearch={true}
          selectOptions={toRoleSelectOptions(props.roles)} />
        <FormCheckbox
          label="Subscribe to connector error emails"
          defaultChecked={props.businessUser.isErrorRecipient}
          onChange={(e) => setValue("errorRecipient", e.target.checked)}
          offset={3}
        />
      </>)}
      footer={(
        <SpinnerButton
          className="btn-ghost-primary"
          spinning={editUser.isLoading}
          onClick={handleSubmit((dto) => editUser.request(dto))}>
          Save
        </SpinnerButton>
      )}
    />
  );
};
